import { render } from "./AddNewAsset.vue?vue&type=template&id=08d196cd&scoped=true"
import script from "./AddNewAsset.vue?vue&type=script&lang=js"
export * from "./AddNewAsset.vue?vue&type=script&lang=js"

import "./AddNewAsset.vue?vue&type=style&index=0&id=08d196cd&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d196cd"]])

export default __exports__